<template>
  <div>
    <a-descriptions bordered :column="1">
      <a-descriptions-item v-for="(label, key) in labelMap" :key="key" :label="label">
        {{ render(license?.license, key) }}
      </a-descriptions-item>
      <a-descriptions-item v-if="expired !== null && expired !== undefined" :label="$t('license.config.expiredStatus')">
        {{ expired ? $t('license.config.expired') : $t('license.config.notExpired') }}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
// const
export default {
  name: 'LicenseConfigDetail',
  props: {
    license: {
      type: Object,
    },
    expired: {
      type: Object,
    },
  },
  data () {
    return {
      labelMap: {
        version: this.$t('license.config.version'),
        vendor: this.$t('license.config.vendor'),
        issuedTo: this.$t('license.config.issuedTo'),
        issuedDate: this.$t('license.config.issuedDate'),
        expirationDate: this.$t('license.config.expirationDate'),
        hypervisorCount: this.$t('license.config.hypervisorCount'),
        baremetalHostCount: this.$t('license.config.baremetalHostCount'),
        products: this.$t('license.config.products'),
        nodes: this.$t('license.config.nodes'),
      },
    }
  },
  methods: {
    render (license, key) {
      if (!(key in license)) {
        return '--'
      }
      if (key === 'expirationDate' || key === 'issuedDate') {
        return new Date(license[key]).toLocaleString()
      }
      if (key === 'products') {
        return Object.keys(license[key]).map(v => v.toUpperCase()).join(', ')
      }
      if (key === 'nodes') {
        return (license[key] ?? []).map(v => v.sn).join('\n')
      }
      return license?.[key]
    },
  },
}
</script>
